import React from 'react';
import LocalizedMessage from 'common/localized-message';
import moment from 'moment';
import { AvatarTeam, Subhead, Text } from 'components/shared/uniform';
import { getSportByName } from 'components/shared/uniform/sport-helpers';

const nonBreakingHyphen = String.fromCharCode(8209);

class RecentScores extends React.Component {
  static propTypes = {
    divider: React.PropTypes.bool.isRequired,
    sportName: React.PropTypes.string,
    events: React.PropTypes.arrayOf(React.PropTypes.shape({
      gameId: React.PropTypes.string.isRequired,
      isHome: React.PropTypes.bool.isRequired,
      isTie: React.PropTypes.bool,
      isWin: React.PropTypes.bool,
      opponentName: React.PropTypes.string.isRequired,
      opponentTeamId: React.PropTypes.string,
      schoolAbbreviation: React.PropTypes.string,
      primaryColor: React.PropTypes.string,
      secondaryColor: React.PropTypes.string,
      teamLogoUri: React.PropTypes.string,
      unixTime: React.PropTypes.number,
      utcTime: React.PropTypes.string,
      hasScore: React.PropTypes.bool.isRequired,
      boxScoreUrl: React.PropTypes.string,
    })),
    teamProfileUrlBase: React.PropTypes.string.isRequired,
    convertTimesToLocal: React.PropTypes.bool.isRequired,
  }
  shouldComponentUpdate(nextProps) {
    return nextProps !== this.props;
  }

  getScore(event) {
    if (!event.hasScore) {
      return null;
    }

    let resultLabel;
    let score;
    if (event.isWin) {
      resultLabel = 'Win';
      score = (
        <Text level="small">
          <strong>{event.ownScore}</strong> {nonBreakingHyphen} {event.opponentScore}
        </Text>
      );
    } else if (event.isTie) {
      resultLabel = <LocalizedMessage id="profiles.team.schedule.tie"/>;
      score = (
        <Text level="small">
          {event.ownScore} {nonBreakingHyphen} {event.opponentScore}
        </Text>
      );
    } else {
      resultLabel = 'Loss';
      score = (
        <Text level="small">
          {event.ownScore} {nonBreakingHyphen} <strong>{event.opponentScore}</strong>
        </Text>
      );
    }

    if (event.boxScoreUrl) {
      return (
        <a className="uni-link--wrapper" href={'/' + event.boxScoreUrl}>
          <div className="score">
            <span className={event.isWin ? 'win' : 'loss'}>
              <Text level="small"><strong>{resultLabel}</strong><br/>{score}</Text>
            </span>
          </div>
        </a>
      );
    }

    return (
      <div className="score">
        <span className={event.isWin ? 'win' : 'loss'}>
          <Text level="small">
            <strong>{resultLabel}</strong>
            <br/>
            <div className="result-score">{score}</div>
          </Text>
        </span>
      </div>
    );
  }

  formatDate(utcTime) {
    if (!utcTime) {
      return null;
    }
    // Grab time offset from end of string
    let parsedDate;
    if (this.props.convertTimesToLocal) {
      parsedDate = moment.utc(utcTime.slice(0, -6)).local();
    } else {
      parsedDate = moment.utc(utcTime).utcOffset(utcTime.slice(-6));
    }

    const day = parsedDate.format('D');
    let month = parsedDate.format('MMMM');

    if (month === 'September') {
      month = 'Sept.';
    } else {
      month = month.length > 5 ? month.substring(0, 3) + '.' : month;
    }

    const dmy = `${day} ${month}`;

    return dmy;
  }

  render() {
    const recentScores = this.props.events || [];
    if (!recentScores.length) {
      return null;
    }

    const divider = this.props.divider ?
      <div className="section-divider"></div> : null;

    return (
      <div>
        {divider}
        <Subhead className="uni-margin--one--btm">Recent</Subhead>
        <ul className="col-team-list">
          {recentScores.map(evt => {
            const getEventScore = this.getScore(evt);
            const time = this.formatDate(evt.utcTime);
            const teamName = `${evt.isHome ? 'vs ' : '@ '} ${evt.opponentName}`;
            const teamContent = (
              <div className="team-container">
                <AvatarTeam
                  className="uni-margin--half--right"
                  size="large"
                  imageUrl={evt.opponentLogoUri}
                  sport={getSportByName(this.props.sportName)}
                  primaryColor={evt.primaryColor}
                  secondaryColor={evt.secondaryColor}
                />
                <div className="team-text">
                  <div className="game-day">
                    <div className="name-and-date">
                      <span className="team-name">
                        <Subhead level="subtle">{teamName}</Subhead>
                      </span>
                      <div className="team-subtext">
                        <Text level="small" color="nonessential">
                          {time}
                        </Text>
                      </div>
                    </div>
                    {getEventScore}
                  </div>
                </div>
              </div>
            );

            const linkedContent = evt.opponentTeamId ? (
              <a href={this.props.teamProfileUrlBase + evt.opponentTeamId}>
                {teamContent}
              </a>
            ) : teamContent;

            return (
              <li className={evt.opponentTeamId ? 'selectable' : ''} key={evt.gameId}>
                {linkedContent}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default RecentScores;
